import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccVenture } from '../acc-ventures-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccVenture, unknown>[] = [
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Id', row => row.accApplicationId, { header: 'accApplicationId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name' }),
		buildColumn(util, 'Text', row => row.teamName, { header: 'Team' }),
		buildColumn(util, 'Text', row => row.entrepreneurNames, { header: 'Entrepreneurs' }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Drop-out Week', hidden: true }),
		buildColumn(util, 'Text', row => row.dropoutReason, { header: 'Drop-out Reason', hidden: true }),
		buildColumn(util, 'Text', row => row.businessType, { header: 'Business Type', hidden: true }),
		buildColumn(util, 'Text', row => row.industry, { header: 'Industry', hidden: true }),
		buildColumn(util, 'Text', row => row.offerings, { header: 'Offerings', hidden: true }),
		buildColumn(util, 'Text', row => row.operatingStatus, { header: 'Operating Status', hidden: true }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status', group: 'desc' }),
	];


	return columns;

}